import React from 'react';
import PropTypes from 'prop-types';
import FAQSearchStyles from './FAQSearch.styled.js';
import SearchIcon from '../Shared/Icons/Search';
import LoadingIcon from '../Shared/Icons/Loading';
import Dropdown from '../Shared/Inputs/Dropdown';
import noop from '../../util/noop';

const FAQSearch = ({
  search = '',
  suggestions = [],
  touched = false,
  isSearching = false,
  onChange = noop,
  onBlur = noop,
  onSubmit = noop,
  error = false,
}) => {
  return (
    <FAQSearchStyles>
      <form onSubmit={onSubmit}>
        <section className='search'>
          <Dropdown
            label='Search FAQs'
            name='searchFaqs'
            onChange={onChange}
            value={search}
            values={suggestions}
            touched={touched}
            onBlur={onBlur}
            showFormatted={false}
            error={error}
            errorInDropdown={true}
            aria-label={`Search FAQs ${isSearching ? '- loading' : ''}`}
            aria-describedby='searchFaqsLabel'
            aria-owns='searchFaqsResults'
            aria-autocomplete='list'
            hasDropdownIcon={false}
          />
          {isSearching ? (
            <button type='submit' tabIndex='-1' title='Searching FAQs'>
              <LoadingIcon />
            </button>
          ) : (
            <button type='submit' tabIndex='-1' title='Search FAQs'>
              <SearchIcon />
            </button>
          )}
        </section>
      </form>
    </FAQSearchStyles>
  );
};

FAQSearch.propTypes = {
  search: PropTypes.string,
  Suggestions: PropTypes.array,
  touched: PropTypes.bool,
  isSearching: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default FAQSearch;
